import { IsString } from "class-validator";

export class PatientRegistrationFormInitDTO {
    @IsString()
    p: string; // encryptedPatientId: string;
    @IsString()
    i: string; // iv: string;
}